import { ProductType } from 'common/core/interfaces/products'

enum ExtendedProductType {
  FREE = 'free',
}

export const TouchedContactLimits: Record<ExtendedProductType | ProductType, number> = {
  [ExtendedProductType.FREE]: 25,
  [ProductType.AUTOMATION]: 0,
  [ProductType.INBOX]: 0,
  [ProductType.ESSENTIAL]: 250,
  [ProductType.PRO]: 2500,
  [ProductType.BUSINESS]: 7500,
  [ProductType.ADVANCED]: 25000,
}
